
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PsPromoApDtGrid extends Serenity.EntityGrid<PsPromoApDtRow, any> {
        protected getColumnsKey() { return PsPromoApDtColumns.columnsKey; }
        protected getDialogType() { return PsPromoApDtDialog; }
        protected getIdProperty() { return PsPromoApDtRow.idProperty; }
        protected getInsertPermission() { return PsPromoApDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoApDtRow.localTextPrefix; }
        protected getService() { return PsPromoApDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        // protected getButtons() {
        //     var buttons = super.getButtons();

        //     // remove first button (Add button)
        //     buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        // }
    }
}